<div>
  <div class="card boxContainer">
    <div class="text-dark text-center font-size-24 mb-4">
      <strong>Account Locked</strong>
    </div>
    <div class="text-center">
      <div class="kit__utils__avatar kit__utils__avatar--size64 d-inline-block mb-2">
        <img src="assets/images/avatars/avatar.png" alt="Avatar" />
      </div>
      <div class="font-size-18 text-dark mb-4">
        <strong>{{name}}</strong>
      </div>
    </div>
    <form nz-form [nzLayout]="'vertical'" [formGroup]="form" (ngSubmit)="submitForm()" role="form">
      <nz-form-item>
        <nz-form-control nzErrorTip="Please input your Password!">
          <input type="password" nz-input nzSize="large" formControlName="password" placeholder="Password" />
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-control>
          <button nz-button nzType="primary" [nzSize]="'large'" [nzLoading]="loading" class="text-center w-100">
            <strong>Unlock Account <span *ngIf="!email"> (unmöglich)</span></strong>
          </button>
        </nz-form-control>
      </nz-form-item>
    </form>
    <div class="text-center pt-2 mb-auto">
      <span class="mr-2">Already have an account?</span>
      <a routerLink="/auth/login" class="kit__utils__link font-size-16">
        Sign in
      </a>
    </div>
		<p *ngIf="email">hinterlegte Email: {{email}}</p>
  </div>
</div>
